export * from './Avatar';
export * from './component/Avatar.component';
